import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import { Sizes } from '../consts/Sizes.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';
import karaoke from '../data/Karaoke.js';

export default class Karaoke extends AbstractScene {
    constructor() {
        super({
            key: 'Karaoke',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.preTarget = () => this.scene.start('End');
        this.postTarget = () => {
            this.isPlaying = false;
            this.video.destroy();
            this.startButton.destroy();
            this.allControls.forEach((control) => control.destroy());
            this.lastScreen();
        };
        this.allControls = [];
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);
        this.missionData = this.getMissionData(karaoke);
        this.videoKey = 'generiqueVideo';

        this.showVideo(this.videoKey); // une fois chargée, on affiche et on contrôle
    }

    lastScreen() {
        this.back = this.add
            .image(this.width / 2, this.height / 2, this.missionData.endScreenimage)
            .setScale(1);
        this.endButton = new ButtonRounded(
            this,
            this.width / 2,
            this.cameras.main.height - 34,
            160 * 2,
            20 * 2,
            'Terminer l’expérience',
            Colors.Text.DarkBlue,
            Colors.Elmt.White,
            false,
            Colors.Text.White,
            true,
            false,
            'arrow-right',
            null
        );
        this.endButton.on('pointerdown', () => {
            this.scene.start('Intro');
        });
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}
